<template src="./Index.html"></template>

<script>
    import BarChart from "@/components/charts/BarChart.js";
    import ChartLayout from "@/components/charts/ChartLayout.vue";

export default {
  components: {
        BarChart,
        ChartLayout
  },
  created() {
    this.getAppointmentsByDoctor();
  },

  data() {
    return {
      appointmentsByDoctor: {},
    };
  },
  methods: {
    getAppointmentsByDoctor() {
      this.$store.dispatch("dashboard/getAppointmentsByDoctor").then((res) => {
        this.appointmentsByDoctor = {
          labels: res.labels,
          datasets: [
            {
              label: "كشف ",
              backgroundColor: "#83c783",
              data: res.counts,
            }, 
             {
              label: "مراجعة",
              backgroundColor: "#9ced9c",
              data: res.reviewCounts,
            },
          
          ],
        };
      });
    },
  },
};
</script>
